export const reductionTypes = Object.freeze({SUM: 'sum', SPAN: 'span', AVERAGE: 'average'});

export const chartTypesMap = [
    {value: 'total_costs', name: 'Costs', apiPath: 'cost/total', reduction: reductionTypes.SUM},
    {value: 'commission', name: 'Commission', apiPath: 'cost/commission', reduction: reductionTypes.SUM},
    {value: 'commission_per_unit', name: 'Commission/Unit', apiPath: 'cost/commission/unit', reduction: reductionTypes.AVERAGE},
    {value: 'freight', name: 'Freight', apiPath: 'cost/freight', reduction: reductionTypes.SUM},
    {value: 'freight_per_unit', name: 'Freight/Unit', apiPath: 'cost/freight/unit', reduction: reductionTypes.AVERAGE},
    {value: 'actual_vcogs', name: 'VCOGS', apiPath: 'cost/vcogs', reduction: reductionTypes.SUM},
    {value: 'actual_vcogs_per_unit', name: 'VCOGS/Unit', apiPath: 'cost/vcogs/unit', reduction: reductionTypes.AVERAGE},
    {value: 'pocket_price_margin', name: 'Pocket Price Margin', apiPath: 'margin/pocket', reduction: reductionTypes.SUM},
    {value: 'pocket_price_margin_per_unit', name: 'Pocket Price Margin/Unit', apiPath: 'margin/pocket/unit', reduction: reductionTypes.AVERAGE},
    {value: 'pocket_price_margin_percent', name: 'Pocket Price Margin %', apiPath: 'margin/pocket/percent', reduction: reductionTypes.AVERAGE},
    {value: 'variable_margin', name: 'Variable Margin', apiPath: 'margin/variable', reduction: reductionTypes.SUM},
    {value: 'variable_margin_per_unit', name: 'Variable Margin/Unit', apiPath: 'margin/variable/unit', reduction: reductionTypes.AVERAGE},
    {value: 'variable_margin_percent', name: 'Variable Margin %', apiPath: 'margin/variable/percent', reduction: reductionTypes.AVERAGE},
    {value: 'gross_price', name: 'Gross Price', apiPath: 'price/gross', reduction: reductionTypes.SPAN},
    {value: 'net_price', name: 'Net Price', apiPath: 'price/net', reduction: reductionTypes.SPAN},
    {value: 'discount', name: 'Discount Amount', apiPath: 'reduction/discount', reduction: reductionTypes.SUM},
    {value: 'discount_per_unit', name: 'Discount Amount/Unit', apiPath: 'reduction/discount/unit', reduction: reductionTypes.AVERAGE},
    {value: 'discount_percent', name: 'Discount %', apiPath: 'reduction/discount/percent', reduction: reductionTypes.AVERAGE},
    {value: 'gross_revenue', name: 'Gross Revenue', apiPath: 'revenue/gross', reduction: reductionTypes.SUM},
    {value: 'net_revenue', name: 'Net Revenue', apiPath: 'revenue/net', reduction: reductionTypes.SUM},
    {value: 'avg_order_value', name: 'Avg Order Value', apiPath: 'revenue/order', reduction: reductionTypes.SPAN},
    {value: 'volume', name: 'Volume', apiPath: 'volume/total', reduction: reductionTypes.SUM},
    {value: 'rebate', name: 'Rebate', apiPath: 'rebate/total', reduction: reductionTypes.SUM}
];

const LEGACY_CALC_TYPE_ALIASES = {
    commission_costs: 'commission',
    unit_commission_costs: 'commission_per_unit',
    freight_costs: 'freight',
    unit_freight_costs: 'freight_per_unit',
    vcogs: 'actual_vcogs',
    unit_vcogs: 'actual_vcogs_per_unit',
    unit_pocket_price_margin: 'pocket_price_margin_per_unit',
    unit_variable_margin: 'variable_margin_per_unit',
    discount_amount: 'discount',
    unit_discount_amount: 'discount_per_unit',
    total_volume: 'volume',
};

export const resolveChartType = (calcType) => {
    const resolved = LEGACY_CALC_TYPE_ALIASES[calcType] || calcType;
    return chartTypesMap.find((t) => t.value === resolved)
        || chartTypesMap.find((t) => t.value === 'net_revenue');
};
